import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "wow.js/css/libs/animate.css?vue&type=style&index=0&lang=css&external"
import "./App.vue?vue&type=style&index=1&id=e196aa4e&lang=css"

const __exports__ = script;

export default __exports__